import mutations from './navbar.mutations'

const state = {
  showMobileNav: false
}

export default {
  namespaced: true,
  state,
  mutations
}
